import { useRef, type DependencyList, type RefObject } from "react";
import { useStickyHorizontalScrollbar } from "~/hooks/useStickyHorizontalScrollbar";
import { cn } from "~/lib/utils";

export const hiddenNativeScrollbarClass =
  "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden";

interface Props {
  targetRef: RefObject<HTMLElement | null>;
  deps: DependencyList;
  className: string;
}

/**
 * Viewport-pinned scrollbar that proxies horizontal scrolling for `targetRef`.
 * Hide the target's own scrollbar with `hiddenNativeScrollbarClass`.
 */
export const StickyHorizontalScrollbar = ({
  targetRef,
  deps,
  className,
}: Props) => {
  const barRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);

  useStickyHorizontalScrollbar({ targetRef, barRef, trackRef, deps });

  return (
    <div ref={barRef} className={cn("hidden overflow-x-auto", className)}>
      <div ref={trackRef} className="h-px" />
    </div>
  );
};
